// extracted by mini-css-extract-plugin
export default {"rootLayoutWithNavigation":"Layout__rootLayoutWithNavigation--p97"};